import { CSS } from '@grupoboticario/flora-react'

export const containerCss: CSS = {
  margin: '$11 $0'
}

export const creditEventCardCss: CSS = {
  fontSize: '$md',
  backgroundColor: '$light-dark-1',
  padding: '$4',
  borderLeft: '4px solid $alert-alt',
  borderTopLeftRadius: '4px',
  borderBottomLeftRadius: '4px'
}

export const auxiliarTextCss: CSS = {
  color: '$nonInteractiveAuxiliar'
}
